import React from 'react';

import Descriptions from '../styled/Descriptions';
import Host from '../styled/Host';
import Paragraph1 from '../styled/Paragraph1';
import Wrapper from '../styled/Wrapper';

const JavaScriptDisabled = () => {
  return (
    <noscript>
      <Host>
        <Wrapper>
          <Descriptions>
            <Paragraph1>Your browser does not support JavaScript!</Paragraph1>
          </Descriptions>
        </Wrapper>
      </Host>
    </noscript>
  );
};

export default JavaScriptDisabled;
